import { WrapperComponents } from "../wrappers/WrapperComponents";
import { HeroSecondary } from "../headers/HeroSecondary";
import { CardResearch } from "../components/cards/CardResearch";
import { SectionGridArchive } from "../sections/grids/SectionGridArchive";
import { Filters } from "../elements/Filters";
import { LoaderDataPage } from "~/data/loaders/page";
import { type TemplateArchiveResearchLibrary } from "~/sanity/types-mapped";

export interface TemplateArchiveResearchLibraryProps {
  data: Pick<LoaderDataPage, "research" | "breadcrumbs"> &
    TemplateArchiveResearchLibrary;
}

export default function TemplateArchiveResearchLibrary({
  data,
}: TemplateArchiveResearchLibraryProps) {
  const { heroSecondary, research, breadcrumbs } = data;

  // console.log("templateArchiveResearchLibrary", data);

  return (
    <>
      {heroSecondary && (
        <HeroSecondary data={heroSecondary} breadcrumbs={breadcrumbs} />
      )}
      <WrapperComponents id="archive">
        <Filters
          items={research?.items.length}
          pagination={research?.pagination}
        >
          {Boolean(research?.items.length) && (
            <SectionGridArchive columns={1}>
              {research?.items.map((item, index) => {
                return (
                  <div style={{ display: "contents" }} key={index}>
                    <CardResearch card={item} />
                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "black",
                      }}
                    ></div>
                  </div>
                );
              })}
            </SectionGridArchive>
          )}
        </Filters>
      </WrapperComponents>
    </>
  );
}
